module.exports = __webpack_public_path__ + "img/live_advanced.e115abf4.png";